import React from "react";

import PageContent from "components/PageContent";
import ContactForm from "components/ContactForm";
import { usePageTitlePrefix } from "hooks/usePageTitlePrefix";

const PageContact: React.FunctionComponent = () => {
	usePageTitlePrefix("Contact Us");

	return (
		<PageContent>
			<header className="major">
				<h1>Contact us</h1>
			</header>
			<p>
				Please fill out your details, along with any other questions or comments
				below, and we'll reply as soon as possible.
			</p>

			<ContactForm
				messagePlaceholder="Your query"
				messageIsRequired
				enquiryType="Standard contact form submission"
			/>
		</PageContent>
	);
};

export default PageContact;
